exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cuProgress-4bade4b4{display:flex;flex-direction:column}.cuProgress-4bade4b4 a,.cuProgress-4bade4b4 a:hover,.cuProgress-4bade4b4 a:visited,.cuProgress-4bade4b4 a:active,.cuProgress-4bade4b4 a:focus{color:inherit;text-decoration:none}.cuProgress-4bade4b4 a.viewOnLeaderboard-0d9bba9d{color:#FA6400;font-weight:500}.cuStats-76b22025{display:flex;flex-flow:row wrap}.cuStats-76b22025 .stat-e28952f4{flex:0 0 50%;max-width:50%;display:flex;flex-direction:column;margin-bottom:10px}.cuStats-76b22025 .metric-b30e333a>:first-child{font-size:22px;line-height:28px}.cuStats-76b22025 .metric-b30e333a>:last-child{font-size:13px;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"cuProgress": "cuProgress-4bade4b4",
	"viewOnLeaderboard": "viewOnLeaderboard-0d9bba9d",
	"cuStats": "cuStats-76b22025",
	"stat": "stat-e28952f4",
	"metric": "metric-b30e333a"
};